export const THREE_MONTH_PERIOD = 'every 3 months';
export const ONE_YEAR_PERIOD = 'yearly';

export const BILLING_CYCLE_PERIODS = {
    [THREE_MONTH_PERIOD]: THREE_MONTH_PERIOD,
    [ONE_YEAR_PERIOD]: ONE_YEAR_PERIOD,
};
